import { lazy } from "react";
import { createRoute } from "@tanstack/react-router";

import CompactLayout from "src/layouts/compact";

import { rootRoute } from "./root";

const ForgotPasswordPage = lazy(() => import('src/sections/forgot-password/forgot-password-view'));

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'forgot-password',
  component: () => (
      <CompactLayout>
        <ForgotPasswordPage />
      </CompactLayout>
    ),
});
